import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { ModernizedStackedBarChartData } from 'src/app/models/chart-models/modernized-stacked-bar-chart';
import { AssetMixViewChoice, AssetMixViewChoiceHadler } from './factor-card.interface';

@Component({
  selector: 'phc-factor-card',
  templateUrl: './factor-card.component.html',
  styleUrls: ['./factor-card.component.scss']
})
export class FactorCardComponent implements OnChanges, OnInit {

  @Input() idChartData: string;
  @Input() actualChartData: ModernizedStackedBarChartData;
  @Input() targetChartData?: ModernizedStackedBarChartData;
  @Output() assetMixViewChoiceSelectedOutput = new EventEmitter();

  isAssetMixChart: boolean = false;
  assetMixViewChoiceSelected: AssetMixViewChoice = 'percentage'

  private emitOutputValue() {
    this.assetMixViewChoiceSelectedOutput.emit(this.assetMixViewChoiceSelected)
  }

  ngOnChanges(changes): void {
    this.actualChartData = changes?.actualChartData?.currentValue
    this.targetChartData = changes?.targetChartData?.currentValue
    this.isAssetMixChart = !!this.actualChartData && !!this.targetChartData
  }

  ngOnInit(): void {
    this.emitOutputValue()
  }

  assetMixViewChoiceChangeHandler(handler: AssetMixViewChoiceHadler) {
    if (!handler.radioGroupState.isSelected) return
    this.assetMixViewChoiceSelected = handler.radioGroupState.inputValue
    this.emitOutputValue()
  }

  formatValues(value: number | string) {
    switch (this.assetMixViewChoiceSelected) {
      case 'currency':
        value = this.formarCurrencyValue(value)
        break
      case 'percentage':
      default:
        value = String(value).concat('%')
        break
    }
    return value
  }

  private formarCurrencyValue(value: number | string) {
    let usedABS = false;
    value = Number(value);

    if (+value < 0) {
      value = Math.abs(+value);
      usedABS = true;
    }

    function sinal() {
      return usedABS ? '-' : '';
    }

    function formatDecimal(val: number) {
      return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)).replace(/\.0$/, '');
    }

    if (value < 1000) {
      return `$${sinal()}${formatDecimal(value)}`;
    }
    if (value < 1_000_000) {
      // Thousand: K
      return `$${sinal()}${formatDecimal(value / 1_000)}K`;
    }
    if (value < 1_000_000_000) {
      // Million: M
      return `$${sinal()}${formatDecimal(value / 1_000_000)}M`;
    }
    if (value < 1_000_000_000_000) {
      // Billion: B
      return `$${sinal()}${formatDecimal(value / 1_000_000_000)}B`;
    }
    if (value < 1_000_000_000_000_000) {
      // Trillion: T
      return `$${sinal()}${formatDecimal(value / 1_000_000_000_000)}T`;
    }
    if (value < 1_000_000_000_000_000_000) {
      // Quadrillion: Qd
      return `$${sinal()}${formatDecimal(value / 1_000_000_000_000_000)}Qd`;
    }
    // Quintillion: Qi
    return `$${sinal()}${formatDecimal(value / 1_000_000_000_000_000_000)}Qi`;
  }
}